<th id="{channel}-icon" class="channel-header">
    <img
    class="channel-icon"
    src="{svg}"
    title="{title}"
    alt="{alt}"/>
</th>